// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3997":"8b76d8429abf9e22","8996":"73065664277d2376"}[chunkId] + ".js";
};